import { Component } from '@angular/core';
import { IValueChange } from '../../../core/interfaces/form-value-change.interface';
import { BFOnValueChange } from '../../../core/interfaces/sdk-profile-hooks.interface';
import { ProfileFormTemplateProviders } from '../../../core/templates/profile-form.template.providers';
import { AbstractProfileFormComponent } from '../../abstract/abstract-profile/abstract-profile-form.component';
import { ValueListForRules } from '../../models/value-list-for-rules.model';

@Component({
  selector: 'app-value-list-for-rules',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class ValueListForRulesComponent extends AbstractProfileFormComponent implements BFOnValueChange {


  fgppValueChanges(change: IValueChange): void {
    if (change.control === ValueListForRules.LIST_ID) {
      this.populateDescriptionControl();
    }
  }

  private populateDescriptionControl(): void {
    const data = this.getDrilldownData(ValueListForRules.LIST_ID);
    const description = data ? data['LIST_TYPES.DESCRIPTION'] : '';
    this.formMgr.get(ValueListForRules.DESCRIPTION).setValue(description);
  }

}
